module.exports = __webpack_public_path__ + "img/arrow-grey.fa5d2a1e.svg";